module.exports = __webpack_public_path__ + "img/type-online.3591c04e.png";